module.exports = __webpack_public_path__ + "assets/LevelInfos.adb88b9299d613725758d5d99ba4f2c4.xml";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/ru-lproj/LevelInfos.xml
// module id = 1036
// module chunks = 0